import { Grid, Card, CardHeader, CardContent } from '@mui/material';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomFormAutoComplete from 'components/inputs/CustomFormAutoComplete/CustomFormAutoComplete';
import CustomFormTextInput from 'components/inputs/CustomFormTextInput/CustomFormTextInput';
import { useSearchCPTs } from 'hooks/useLookups';
import CalcIcon from 'icons/CalcIcon';
import React, { useState } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form';
import useGlobalStyles from 'styles/globalStyles';
import { CPT } from 'types/types/Types';
import useStyles from './styles';

export default function RVUsCalculatorSection() {
  const globalStyles = useGlobalStyles();
  const styles = useStyles();
  const [options, setOptions] = useState<CPT[]>([]);
  const [keyword, setKeyword] = useState<string>('');

  const { control, register } = useFormContext();

  const { fields } = useFieldArray({
    control,
    name: 'cpts',
  })

  const { isLoading, isFetching } = useSearchCPTs(keyword, {
    enabled: !!keyword,
    keepPreviousData: false,
    onSuccess: (data: any) => {
      const cptOptions = Array.isArray(data)
        ? data
        : Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data?.results)
            ? data.results
            : [];

      setOptions(cptOptions);
    },
    onError: (error: any) => {
      console.log('error', error);
    }
  });

  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Card className={styles.card}>
        <CardHeader
          avatar={<CalcIcon size={22} color='white' />}
          title="RVU Calculator"
          className={globalStyles.sectionPrimaryHeader}
          slotProps={{
            title: {
              className: globalStyles.sectionPrimaryHeaderTitle,
            },
          }}
        />
        <CardContent className={styles.cardContent}>
          <Grid container spacing={1.5}>
            {fields.map((field, index) => (
              <React.Fragment key={field.id}>

                {/* CPT Code */}
                <Grid size={{ xs: 12, md: 6 }}>
                  <CustomFormAutoComplete<CPT>
                    name={`cpts.${index}`}
                    control={control}
                    label="CPT Code"
                    placeholder="CPT code here"
                    options={options}
                    getOptionLabel={(cpt) => cpt.code ? `${cpt.code} - ${cpt.value}` : ''}
                    onInput={(e: any) => {
                      setKeyword(e.target.value);
                    }}
                    loading={isLoading || isFetching}
                  />
                </Grid>

                {/* Quantity */}
                <Grid size={{ xs: 12, md: 6 }}>
                  <CustomFormTextInput
                    name={`cpts.${index}.quantity`}
                    register={register}
                    label="Number of units"
                    placeholder="00.00"
                    type="number"
                  />
                </Grid>
                
              </React.Fragment>
            ))}

            <Grid size={{ xs: 12 }} mt={1}>
              <CustomButton
                text='Calculate'
                fullWidth
                color='primary'
                type='submit'
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  )
}
